import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getApplicationQuestionableAvailableColumns, getPositions } from './api';

export const path = '/application-questionable/list';

const PageApplicationQuestionableList: React.FC = (props) => {
  const ApplicationQuestionableList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getApplicationQuestionableAvailableColumns,
      positions: getPositions,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} columns={loaded.columns} />;
    },
  });

  return <ApplicationQuestionableList {...props} />;
};

export default PageApplicationQuestionableList;
